import { useStaticQuery, graphql } from "gatsby"

export const usePage = () => {
  const { cart, login, register, addresses, dashboard, orders, preferences } = useStaticQuery(graphql`
    query PAGE {
      cart: sanityPageCart {
        donationEnabled
        donationTitle
        donationContent: _rawDonationContent(resolveReferences: { maxDepth: 2 })
        donationImage: _rawDonationImage(resolveReferences: { maxDepth: 2 })
        additionalPageTitle
        additionalCheckoutButton
        additionalGeneralFeatureContentsOne
        additionalGeneralFeatureContentsTwo
        additionalFooterText
      }
      login: sanityPageAccountLogin {
        additionalSubmitButton
      }
      register: sanityPageAccountRegister {
        additionalSubmitButton
      }
      addresses: sanityPageAccountAddresses {
        title
        content: _rawContent(resolveReferences: { maxDepth: 2 })
      }
      dashboard: sanityPageAccountDashboard {
        title
        content: _rawContent(resolveReferences: { maxDepth: 2 })
        additionalLogoutButton
        additionalGreeting
      }
      orders: sanityPageAccountOrders {
        title
        content: _rawContent(resolveReferences: { maxDepth: 2 })
        additionalOrderNo
        additionalDate
        additionalStatus
        additionalTotalPrice
        additionalMore
        additionalTracking
        additionalOrderAgain
        additionalInTransit
        additionalDelivered
      }
      preferences: sanityPageAccountPreferences {
        title
        content: _rawContent(resolveReferences: { maxDepth: 2 })
        additionalFirstName
        additionalLastName
        additionalEmail
        additionalAcceptMarketing
        additionalAcceptMarketingCheckbox
      }
    }
  `)
  return {
    cart,
    login,
    register,
    addresses,
    dashboard,
    orders,
    preferences,
  }
}
